<div class="formular-submit-failed-snack-bar">
    <ng-container>
        <div class="formular-submit-failed-snack-bar__content">
            <div class="formular-submit-failed-snack-bar__content__message">
                <h1 class="text-h2">Formular Einreichung fehlgeschlagen</h1>
                <p class="text-plain">
                    Sehr geehrte/r Antragsteller/in, es kam zu einem Fehler beim Einreichen ihres Antrags. Bitte versuchen Sie es zu einem späteren
                    Zeitpunkt erneut. Wenn Sie Fragen haben oder Unterstützung benötigen, melden Sie sich bitte:<br /><br />VFA-Hotline: +49 (42) 424242-0
                  <br />Montag bis Freitag von 9 bis 15 Uhr <br /><br />oder per E-Mail: {{ email }}
                </p>
            </div>
            <app-button
                class="formular-submit-failed-snack-bar__content__button"
                [isButton]="true"
                buttonLabel="Schließen"
                (clickEvent)="closeSnackBar()"></app-button>
        </div>
    </ng-container>
</div>
